<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="billing-and-payments-screen vouchers-screen">

    <div class="page-heading">
      <div>
        <h3>{{ 'vouchers.title' | translate }}</h3>
        <p class="page-subtitle">{{ 'vouchers.subtitle' | translate }}</p>
      </div>
      <div class="heading-right">
        <!-- Each tab's search sits beside the page actions, as on the other list screens. -->
        <div class="search" *ngIf="activeTab === 'batches'">
          <input type="text" class="form-control" [(ngModel)]="batchSearch" (input)="onBatchSearch()"
            [placeholder]="'vouchers.filters.searchBatch' | translate"
            [attr.aria-label]="'vouchers.filters.searchBatch' | translate"
            autocapitalize="off" style="text-transform: none;" />
          <i class="fa-solid fa-magnifying-glass"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="batchSearch" (click)="batchSearch = ''; onBatchSearch()"></i>
        </div>
        <div class="search" *ngIf="activeTab === 'vouchers'">
          <input type="text" class="form-control" [(ngModel)]="voucherSearch" (input)="onVoucherSearch()"
            [placeholder]="'vouchers.filters.searchVoucher' | translate"
            [attr.aria-label]="'vouchers.filters.searchVoucher' | translate"
            autocapitalize="off" style="text-transform: none;" />
          <i class="fa-solid fa-magnifying-glass"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="voucherSearch" (click)="voucherSearch = ''; onVoucherSearch()"></i>
        </div>
        <div class="search" *ngIf="activeTab === 'usage'">
          <input type="text" class="form-control" [(ngModel)]="usageSearch" (input)="onUsageSearch()"
            [placeholder]="'vouchers.filters.searchUsage' | translate"
            [attr.aria-label]="'vouchers.filters.searchUsage' | translate"
            autocapitalize="off" style="text-transform: none;" />
          <i class="fa-solid fa-magnifying-glass"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="usageSearch" (click)="usageSearch = ''; onUsageSearch()"></i>
        </div>
        <button type="button" class="btn btn-light filter-btn" *ngIf="activeTab === 'vouchers'"
          (click)="exportVouchers()" [disabled]="exporting">
          <i class="fa-solid fa-file-csv"></i>
          <span>{{ 'vouchers.export.vouchers' | translate }}</span>
        </button>
        <button type="button" class="btn btn-light filter-btn" *ngIf="activeTab === 'usage'"
          (click)="exportUsage()" [disabled]="exporting">
          <i class="fa-solid fa-file-csv"></i>
          <span>{{ 'vouchers.export.usage' | translate }}</span>
        </button>
        <button type="button" class="btn btn-primary" *ngIf="canManage" (click)="openCreate()">
          <i class="fa-solid fa-plus me-2"></i>
          {{ 'vouchers.create.button' | translate }}
        </button>
      </div>
    </div>

    <!-- ───────────────────────── Voucher budget ───────────────────────── -->
    <section class="budget-card" [attr.aria-label]="'vouchers.budget.title' | translate" [class.is-loading]="budgetLoading && !budget">
      <ng-container *ngIf="budget; else budgetFallback">
        <div class="budget-main">
          <span class="budget-label">{{ 'vouchers.budget.available' | translate }}</span>
          <div class="budget-figure">
            <strong>{{ budget.balance.local | number: '1.2-2' }}</strong>
            <span class="budget-currency">{{ budgetCurrency }}</span>
          </div>
          <span class="budget-usd" *ngIf="!budgetIsUsd">&asymp; {{ budget.balance.usd | number: '1.2-2' }} USD</span>
        </div>

        <dl class="budget-stats">
          <div>
            <dt>{{ 'vouchers.budget.credited' | translate }}</dt>
            <dd>{{ budget.credited.usd | number: '1.2-2' }} USD</dd>
          </div>
          <div>
            <dt>{{ 'vouchers.budget.spent' | translate }}</dt>
            <dd>{{ budget.spent.usd | number: '1.2-2' }} USD</dd>
          </div>
          <div *ngIf="!budgetIsUsd">
            <dt>{{ 'vouchers.budget.rate' | translate }}</dt>
            <dd>1 USD = {{ budget.usd_to_local_rate | number: '1.0-4' }} {{ budgetCurrency }}</dd>
          </div>
        </dl>

        <div class="budget-actions">
          <button type="button" class="btn btn-light filter-btn" (click)="switchTab('budget')">
            <i class="fa-solid fa-clock-rotate-left"></i>
            <span>{{ 'vouchers.budget.history' | translate }}</span>
          </button>
          <button type="button" class="btn btn-dark" *ngIf="canManage && !budget.pending_request" (click)="openRequest()">
            <i class="fa-solid fa-hand-holding-dollar me-2"></i>{{ 'vouchers.budget.request.button' | translate }}
          </button>
        </div>

        <div class="budget-note pending" *ngIf="budget.pending_request as p" role="status">
          <i class="fa-regular fa-hourglass-half"></i>
          <span>
            {{ 'vouchers.budget.pending' | translate: { amount: (p.amount.usd | number: '1.2-2'), date: (p.created_at | date: 'dd/MM/yyyy') } }}
            <ng-container *ngIf="!budgetIsUsd">(&asymp; {{ p.amount.local | number: '1.2-2' }} {{ budgetCurrency }})</ng-container>
          </span>
          <button type="button" class="btn btn-link btn-sm" *ngIf="canManage" [disabled]="withdrawing" (click)="confirmWithdrawRequest()">
            {{ 'vouchers.budget.withdraw.button' | translate }}
          </button>
        </div>
        <div class="budget-note" *ngIf="!budget.pending_request && budget.balance.usd <= 0">
          <i class="fa-solid fa-circle-info"></i>
          <span>{{ 'vouchers.budget.emptyHint' | translate }}</span>
        </div>
      </ng-container>

      <ng-template #budgetFallback>
        <div class="budget-main" *ngIf="budgetLoading">
          <span class="budget-label">{{ 'vouchers.budget.available' | translate }}</span>
          <div class="budget-skeleton" aria-hidden="true"></div>
        </div>
        <div class="budget-note error" *ngIf="!budgetLoading && budgetError" role="alert">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span>{{ budgetError }}</span>
          <button type="button" class="btn btn-link btn-sm" (click)="loadBudget(1)">{{ 'vouchers.state.retry' | translate }}</button>
        </div>
      </ng-template>
    </section>

    <div class="custom-tabs-container">
      <div class="custom-tabs-header">
        <ul class="custom-nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link" role="tab" [class.active]="activeTab === 'batches'" (click)="switchTab('batches')">
              {{ 'vouchers.tabs.batches' | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" role="tab" [class.active]="activeTab === 'vouchers'" (click)="switchTab('vouchers')">
              {{ 'vouchers.tabs.vouchers' | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" role="tab" [class.active]="activeTab === 'usage'" (click)="switchTab('usage')">
              {{ 'vouchers.tabs.usage' | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" role="tab" [class.active]="activeTab === 'budget'" (click)="switchTab('budget')">
              {{ 'vouchers.tabs.budget' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- ───────────────────────── Batches ───────────────────────── -->
    <div class="luqta-card" *ngIf="activeTab === 'batches'">
      <div class="card-heading">
        <h3>{{ 'vouchers.batchesHeading' | translate: { count: batchState.total } }}</h3>
      </div>

      <div class="filter-bar">
        <div class="filter-item">
          <nz-select [(ngModel)]="batchSource" (ngModelChange)="loadBatches(1)" nzAllowClear
            [nzPlaceHolder]="'vouchers.filters.allSources' | translate" style="width: 100%" [nzOptionOverflowSize]="5">
            <nz-option nzValue="MANUAL" [nzLabel]="'vouchers.source.MANUAL' | translate"></nz-option>
            <nz-option nzValue="CONTEST_PRIZE" [nzLabel]="'vouchers.source.CONTEST_PRIZE' | translate"></nz-option>
          </nz-select>
        </div>
        <button type="button" class="btn btn-link clear-filters" *ngIf="hasBatchFilters" (click)="clearBatchFilters()">
          {{ 'vouchers.filters.clear' | translate }}
        </button>
      </div>

      <nz-table #batchTable [nzData]="batches" [nzBordered]="true" [nzScroll]="{ x: '1420px' }"
        [nzFrontPagination]="false" [nzLoading]="batchState.loading" [nzPageSize]="batchState.limit"
        [nzPageIndex]="batchState.page" [nzTotal]="batchState.total" [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]" [nzNoResult]="batchEmpty"
        (nzPageIndexChange)="loadBatches($event)" (nzPageSizeChange)="onBatchPageSize($event)">
        <thead>
          <tr>
            <th nzWidth="220px">{{ 'vouchers.cols.batch' | translate }}</th>
            <th nzWidth="120px">{{ 'vouchers.cols.status' | translate }}</th>
            <th nzWidth="130px">{{ 'vouchers.cols.prizeValue' | translate }}</th>
            <th nzWidth="200px">{{ 'vouchers.cols.useType' | translate }}</th>
            <th nzWidth="100px">{{ 'vouchers.cols.quantity' | translate }}</th>
            <th nzWidth="230px">{{ 'vouchers.cols.counts' | translate }}</th>
            <th nzWidth="130px">{{ 'vouchers.cols.totalValue' | translate }}</th>
            <th nzWidth="140px">
              {{ 'vouchers.cols.stillToSpend' | translate }}
              <span nz-tooltip [nzTooltipTitle]="'vouchers.cols.stillToSpendTip' | translate" nzTooltipPlacement="top">
                <i class="fa-solid fa-circle-info col-info"></i>
              </span>
            </th>
            <th nzWidth="150px" nzRight>{{ 'vouchers.cols.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let b of batchTable.data; trackBy: trackById">
            <td>
              <div class="batch-name">{{ b.name }}</div>
              <span class="source-tag" [class.contest]="b.source === 'CONTEST_PRIZE'">
                {{ 'vouchers.source.' + b.source | translate }}
              </span>
            </td>
            <td>
              <span class="status-tag" [ngClass]="statusClass(b.status)">
                {{ 'vouchers.status.' + b.status | translate }}
              </span>
            </td>
            <td class="num">
              {{ b.face_value | number: '1.0-2' }} {{ b.currency }}
              <small class="sub" *ngIf="b.currency !== 'USD'">&asymp; {{ b.face_value_usd | number: '1.0-2' }} USD</small>
            </td>
            <td class="wrap">
              <ng-container *ngIf="ruleSummary(b) as r">{{ r.key | translate: r.params }}</ng-container>
            </td>
            <td class="num">{{ b.quantity | number }}</td>
            <td>
              <div class="counts">
                <span nz-tooltip [nzTooltipTitle]="'vouchers.counts.issuedTip' | translate"><b>{{ b.counts?.issued ?? 0 }}</b> {{ 'vouchers.counts.issued' | translate }}</span>
                <span nz-tooltip [nzTooltipTitle]="'vouchers.counts.assignedTip' | translate"><b>{{ b.counts?.assigned ?? 0 }}</b> {{ 'vouchers.counts.assigned' | translate }}</span>
                <span nz-tooltip [nzTooltipTitle]="'vouchers.counts.usedTip' | translate"><b>{{ b.counts?.used ?? 0 }}</b> {{ 'vouchers.counts.used' | translate }}</span>
                <span nz-tooltip [nzTooltipTitle]="'vouchers.counts.redeemedTip' | translate"><b>{{ b.counts?.redeemed ?? 0 }}</b> {{ 'vouchers.counts.redeemed' | translate }}</span>
                <span *ngIf="b.counts?.voided"><b>{{ b.counts.voided }}</b> {{ 'vouchers.counts.voided' | translate }}</span>
              </div>
            </td>
            <td class="num">{{ b.total_value | number: '1.0-2' }} {{ b.currency }}</td>
            <td class="num">{{ b.outstanding_value | number: '1.0-2' }} {{ b.currency }}</td>
            <td nzRight>
              <div class="row-actions">
                <button type="button" class="icon-btn" nz-tooltip [nzTooltipTitle]="'vouchers.actions.viewVouchers' | translate"
                  [attr.aria-label]="'vouchers.actions.viewVouchers' | translate" (click)="viewBatchVouchers(b)">
                  <i class="fa-solid fa-list"></i>
                </button>
                <button type="button" class="icon-btn" nz-tooltip [nzTooltipTitle]="'vouchers.actions.viewUsage' | translate"
                  [attr.aria-label]="'vouchers.actions.viewUsage' | translate" (click)="viewBatchUsage(b)">
                  <i class="fa-solid fa-receipt"></i>
                </button>
                <button type="button" class="icon-btn" nz-tooltip [nzTooltipTitle]="'vouchers.actions.exportCodes' | translate"
                  [attr.aria-label]="'vouchers.actions.exportCodes' | translate" [disabled]="exporting"
                  (click)="exportBatchCodes(b)">
                  <i class="fa-solid fa-file-csv"></i>
                </button>
                <button type="button" class="icon-btn danger" *ngIf="canManage && canVoidBatch(b)" nz-tooltip
                  [nzTooltipTitle]="'vouchers.actions.voidRemaining' | translate"
                  [attr.aria-label]="'vouchers.actions.voidRemaining' | translate" [disabled]="voiding"
                  (click)="confirmVoidBatch(b)">
                  <i class="fa-solid fa-ban"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <ng-template #batchEmpty>
        <div class="state-block" *ngIf="batchState.error as msg; else batchNone">
          <i class="fa-solid fa-triangle-exclamation error-icon"></i>
          <h4>{{ 'vouchers.state.errorTitle' | translate }}</h4>
          <p>{{ msg }}</p>
          <button type="button" class="btn btn-dark" (click)="loadBatches(1)">{{ 'vouchers.state.retry' | translate }}</button>
        </div>
        <ng-template #batchNone>
          <div class="state-block" *ngIf="!batchState.loading">
            <i class="fa-solid fa-ticket"></i>
            <h4>{{ (hasBatchFilters ? 'vouchers.state.noMatchTitle' : 'vouchers.state.batchesEmptyTitle') | translate }}</h4>
            <p>{{ (hasBatchFilters ? 'vouchers.state.noMatchText' : 'vouchers.state.batchesEmptyText') | translate }}</p>
            <button type="button" class="btn btn-primary" *ngIf="canManage && !hasBatchFilters" (click)="openCreate()">
              {{ 'vouchers.create.button' | translate }}
            </button>
          </div>
        </ng-template>
      </ng-template>
    </div>

    <!-- ───────────────────────── Vouchers ───────────────────────── -->
    <div class="luqta-card" *ngIf="activeTab === 'vouchers'">
      <div class="card-heading">
        <h3>{{ 'vouchers.tabs.vouchers' | translate }} ({{ voucherState.total }})</h3>
        <div class="bulk-bar" *ngIf="canManage && selected.size > 0">
          <span>{{ 'vouchers.void.selected' | translate: { count: selected.size } }}</span>
          <button type="button" class="btn btn-danger btn-sm" [disabled]="voiding" (click)="confirmVoidSelected()">
            <i class="fa-solid fa-ban me-1"></i>{{ 'vouchers.void.selectedButton' | translate }}
          </button>
          <button type="button" class="btn btn-link btn-sm" (click)="selected.clear()">
            {{ 'vouchers.void.clearSelection' | translate }}
          </button>
        </div>
      </div>

      <div class="filter-bar">
        <div class="filter-item">
          <nz-select [(ngModel)]="voucherBatchId" (ngModelChange)="loadVouchers(1)" nzAllowClear nzShowSearch
            [nzPlaceHolder]="'vouchers.filters.allBatches' | translate" style="width: 100%" [nzOptionOverflowSize]="5">
            <nz-option *ngFor="let b of batchOptions" [nzValue]="b.id" [nzLabel]="b.name"></nz-option>
          </nz-select>
        </div>
        <div class="filter-item">
          <nz-select [(ngModel)]="voucherStatus" (ngModelChange)="loadVouchers(1)" nzAllowClear
            [nzPlaceHolder]="'vouchers.filters.allStatuses' | translate" style="width: 100%" [nzOptionOverflowSize]="5">
            <nz-option *ngFor="let s of statuses" [nzValue]="s" [nzLabel]="'vouchers.status.' + s | translate"></nz-option>
          </nz-select>
        </div>
        <button type="button" class="btn btn-link clear-filters" *ngIf="hasVoucherFilters" (click)="clearVoucherFilters()">
          {{ 'vouchers.filters.clear' | translate }}
        </button>
      </div>

      <nz-table #voucherTable [nzData]="vouchers" [nzBordered]="true" [nzScroll]="{ x: '1820px' }"
        [nzFrontPagination]="false" [nzLoading]="voucherState.loading" [nzPageSize]="voucherState.limit"
        [nzPageIndex]="voucherState.page" [nzTotal]="voucherState.total" [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]" [nzNoResult]="voucherEmpty"
        (nzPageIndexChange)="loadVouchers($event)" (nzPageSizeChange)="onVoucherPageSize($event)">
        <thead>
          <tr>
            <th nzWidth="46px" [nzShowCheckbox]="canManage" [nzChecked]="allSelected" [nzIndeterminate]="someSelected"
              [nzDisabled]="!selectableVouchers.length" (nzCheckedChange)="toggleAll($event)"></th>
            <th nzWidth="230px">{{ 'vouchers.cols.code' | translate }}</th>
            <th nzWidth="140px">{{ 'vouchers.cols.status' | translate }}</th>
            <th nzWidth="130px">{{ 'vouchers.cols.faceValue' | translate }}</th>
            <th nzWidth="130px">{{ 'vouchers.cols.remaining' | translate }}</th>
            <th nzWidth="130px">{{ 'vouchers.cols.spent' | translate }}</th>
            <th nzWidth="124px">{{ 'vouchers.cols.uses' | translate }}</th>
            <th nzWidth="170px">{{ 'vouchers.cols.assignedTo' | translate }}</th>
            <th nzWidth="170px">{{ 'vouchers.cols.contest' | translate }}</th>
            <th nzWidth="190px">{{ 'vouchers.cols.batch' | translate }}</th>
            <th nzWidth="120px">{{ 'vouchers.cols.expires' | translate }}</th>
            <th nzWidth="150px">{{ 'vouchers.cols.created' | translate }}</th>
            <th nzWidth="90px" nzRight>{{ 'vouchers.cols.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of voucherTable.data; trackBy: trackById">
            <td [nzShowCheckbox]="canManage && canVoid(v)" [nzChecked]="selected.has(v.voucher_id)"
              (nzCheckedChange)="toggleOne(v.voucher_id, $event)"></td>
            <td>
              <span class="code-cell">
                <code class="code-text">{{ v.code }}</code>
                <button type="button" class="icon-btn" nz-tooltip [nzTooltipTitle]="'vouchers.actions.copy' | translate"
                  [attr.aria-label]="'vouchers.actions.copy' | translate" (click)="copyCode(v.code)">
                  <i class="fa-regular fa-copy"></i>
                </button>
              </span>
            </td>
            <td>
              <span class="status-tag" [ngClass]="statusClass(v.status)">
                {{ 'vouchers.status.' + v.status | translate }}
              </span>
            </td>
            <td class="num">{{ v.face_value | number: '1.0-2' }} {{ v.currency }}</td>
            <td class="num">{{ v.remaining_value | number: '1.0-2' }} {{ v.currency }}</td>
            <td class="num">{{ v.spent | number: '1.0-2' }} {{ v.currency }}</td>
            <td class="num">{{ usesLabel(v) }}</td>
            <td class="wrap">
              <ng-container *ngIf="v.assigned_to; else dash">{{ v.assigned_to.name || ('vouchers.assignedUnnamed' | translate) }}</ng-container>
            </td>
            <td class="wrap">{{ v.contest?.name || '-' }}</td>
            <td class="wrap">{{ v.batch?.name || '-' }}</td>
            <td>{{ v.expires_at | date: 'dd/MM/yyyy':'UTC' }}</td>
            <td>{{ v.created_at | date: 'dd/MM/yyyy, h:mm a' }}</td>
            <td nzRight>
              <div class="row-actions">
                <button type="button" class="icon-btn danger" *ngIf="canManage && canVoid(v)" nz-tooltip
                  [nzTooltipTitle]="'vouchers.actions.void' | translate"
                  [attr.aria-label]="'vouchers.actions.void' | translate" [disabled]="voiding"
                  (click)="confirmVoidVoucher(v)">
                  <i class="fa-solid fa-ban"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <ng-template #voucherEmpty>
        <div class="state-block" *ngIf="voucherState.error as msg; else voucherNone">
          <i class="fa-solid fa-triangle-exclamation error-icon"></i>
          <h4>{{ 'vouchers.state.errorTitle' | translate }}</h4>
          <p>{{ msg }}</p>
          <button type="button" class="btn btn-dark" (click)="loadVouchers(1)">{{ 'vouchers.state.retry' | translate }}</button>
        </div>
        <ng-template #voucherNone>
          <div class="state-block" *ngIf="!voucherState.loading">
            <i class="fa-solid fa-ticket"></i>
            <h4>{{ (hasVoucherFilters ? 'vouchers.state.noMatchTitle' : 'vouchers.state.vouchersEmptyTitle') | translate }}</h4>
            <p>{{ (hasVoucherFilters ? 'vouchers.state.noMatchText' : 'vouchers.state.vouchersEmptyText') | translate }}</p>
          </div>
        </ng-template>
      </ng-template>
    </div>

    <!-- ───────────────────────── Usage ───────────────────────── -->
    <div class="luqta-card" *ngIf="activeTab === 'usage'">
      <div class="card-heading">
        <h3>{{ 'vouchers.tabs.usage' | translate }} ({{ usageState.total }})</h3>
      </div>

      <div class="totals-row" *ngIf="usageTotals.length">
        <div class="total-card" *ngFor="let t of usageTotals">
          <span class="total-currency">{{ t.currency }}</span>
          <div>
            <small>{{ 'vouchers.usage.totalSpent' | translate }}</small>
            <strong>{{ t.spent | number: '1.0-2' }}</strong>
          </div>
          <div>
            <small>{{ 'vouchers.usage.totalForfeited' | translate }}</small>
            <strong>{{ t.forfeited | number: '1.0-2' }}</strong>
          </div>
        </div>
      </div>

      <div class="filter-bar">
        <div class="filter-item">
          <nz-select [(ngModel)]="usageBatchId" (ngModelChange)="loadUsage(1)" nzAllowClear nzShowSearch
            [nzPlaceHolder]="'vouchers.filters.allBatches' | translate" style="width: 100%" [nzOptionOverflowSize]="5">
            <nz-option *ngFor="let b of batchOptions" [nzValue]="b.id" [nzLabel]="b.name"></nz-option>
          </nz-select>
        </div>
        <div class="filter-item filter-range">
          <nz-range-picker [(ngModel)]="usageRange" (ngModelChange)="loadUsage(1)" nzFormat="dd/MM/yyyy"
            style="width: 100%"
            [nzPlaceHolder]="[('vouchers.filters.from' | translate), ('vouchers.filters.to' | translate)]">
          </nz-range-picker>
        </div>
        <button type="button" class="btn btn-link clear-filters" *ngIf="hasUsageFilters" (click)="clearUsageFilters()">
          {{ 'vouchers.filters.clear' | translate }}
        </button>
      </div>

      <nz-table #usageTable [nzData]="usage" [nzBordered]="true" [nzScroll]="{ x: '1840px' }"
        [nzFrontPagination]="false" [nzLoading]="usageState.loading" [nzPageSize]="usageState.limit"
        [nzPageIndex]="usageState.page" [nzTotal]="usageState.total" [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]" [nzNoResult]="usageEmpty"
        (nzPageIndexChange)="loadUsage($event)" (nzPageSizeChange)="onUsagePageSize($event)">
        <thead>
          <tr>
            <th nzWidth="160px">{{ 'vouchers.cols.date' | translate }}</th>
            <th nzWidth="110px">{{ 'vouchers.cols.kind' | translate }}</th>
            <th nzWidth="230px">{{ 'vouchers.cols.code' | translate }}</th>
            <th nzWidth="190px">{{ 'vouchers.cols.batch' | translate }}</th>
            <th nzWidth="130px">{{ 'vouchers.cols.amount' | translate }}</th>
            <th nzWidth="130px">{{ 'vouchers.cols.forfeited' | translate }}</th>
            <th nzWidth="150px">{{ 'vouchers.cols.balanceBefore' | translate }}</th>
            <th nzWidth="150px">{{ 'vouchers.cols.balanceAfter' | translate }}</th>
            <th nzWidth="220px">{{ 'vouchers.cols.order' | translate }}</th>
            <th nzWidth="220px">{{ 'vouchers.cols.item' | translate }}</th>
            <th nzWidth="150px">{{ 'vouchers.cols.orderTotal' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of usageTable.data; trackBy: trackById">
            <td>{{ u.created_at | date: 'dd/MM/yyyy, h:mm a' }}</td>
            <td>
              <span class="status-tag" [ngClass]="u.kind === 'REVERSAL' ? 'status-expired' : 'status-active'">
                {{ 'vouchers.kind.' + u.kind | translate }}
              </span>
            </td>
            <td>
              <span class="code-cell">
                <code class="code-text">{{ u.code }}</code>
                <button type="button" class="icon-btn" nz-tooltip [nzTooltipTitle]="'vouchers.actions.copy' | translate"
                  [attr.aria-label]="'vouchers.actions.copy' | translate" (click)="copyCode(u.code)">
                  <i class="fa-regular fa-copy"></i>
                </button>
              </span>
            </td>
            <td class="wrap">{{ u.batch_name || '-' }}</td>
            <td class="num">{{ u.amount | number: '1.0-2' }} {{ u.currency }}</td>
            <td class="num">{{ u.forfeited | number: '1.0-2' }} {{ u.currency }}</td>
            <td class="num">{{ u.balance_before | number: '1.0-2' }} {{ u.currency }}</td>
            <td class="num">{{ u.balance_after | number: '1.0-2' }} {{ u.currency }}</td>
            <td class="wrap">
              <ng-container *ngIf="u.order; else dash">
                {{ u.order.reference }}
                <small class="sub" *ngIf="u.order.status">{{ u.order.status }}</small>
              </ng-container>
            </td>
            <td class="wrap">
              <ng-container *ngIf="itemName(u) as item; else dash">
                {{ item }}
                <small class="sub" *ngIf="u.order?.brand">{{ u.order.brand }}</small>
              </ng-container>
            </td>
            <td class="num">
              <ng-container *ngIf="u.order; else dash">
                {{ u.order.total | number: '1.0-2' }} {{ u.order.currency }}
                <small class="sub" *ngIf="u.order_currency && u.order_currency !== u.currency && u.conversion_rate">
                  1 {{ u.order_currency }} = {{ u.conversion_rate | number: '1.0-4' }} {{ u.currency }}
                </small>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <ng-template #usageEmpty>
        <div class="state-block" *ngIf="usageState.error as msg; else usageNone">
          <i class="fa-solid fa-triangle-exclamation error-icon"></i>
          <h4>{{ 'vouchers.state.errorTitle' | translate }}</h4>
          <p>{{ msg }}</p>
          <button type="button" class="btn btn-dark" (click)="loadUsage(1)">{{ 'vouchers.state.retry' | translate }}</button>
        </div>
        <ng-template #usageNone>
          <div class="state-block" *ngIf="!usageState.loading">
            <i class="fa-solid fa-receipt"></i>
            <h4>{{ (hasUsageFilters ? 'vouchers.state.noMatchTitle' : 'vouchers.state.usageEmptyTitle') | translate }}</h4>
            <p>{{ (hasUsageFilters ? 'vouchers.state.noMatchText' : 'vouchers.state.usageEmptyText') | translate }}</p>
          </div>
        </ng-template>
      </ng-template>
    </div>

    <!-- ───────────────────────── Budget history ───────────────────────── -->
    <ng-container *ngIf="activeTab === 'budget'">
      <div class="luqta-card">
        <div class="card-heading">
          <h3>{{ 'vouchers.budget.ledgerTitle' | translate }} ({{ budgetState.total }})</h3>
        </div>
        <p class="card-intro">{{ 'vouchers.budget.ledgerIntro' | translate }}</p>

        <nz-table #entryTable [nzData]="budgetEntries" [nzBordered]="true" [nzScroll]="{ x: '1100px' }"
          [nzFrontPagination]="false" [nzLoading]="budgetState.loading" [nzPageSize]="budgetState.limit"
          [nzPageIndex]="budgetState.page" [nzTotal]="budgetState.total" [nzShowSizeChanger]="true"
          [nzPageSizeOptions]="[10, 20, 50, 100]" [nzNoResult]="entryEmpty"
          (nzPageIndexChange)="loadBudget($event)" (nzPageSizeChange)="onBudgetPageSize($event)">
          <thead>
            <tr>
              <th nzWidth="160px">{{ 'vouchers.cols.date' | translate }}</th>
              <th nzWidth="170px">{{ 'vouchers.cols.kind' | translate }}</th>
              <th nzWidth="170px">{{ 'vouchers.cols.amount' | translate }}</th>
              <th nzWidth="170px">{{ 'vouchers.budget.cols.balanceAfter' | translate }}</th>
              <th nzWidth="200px">{{ 'vouchers.cols.batch' | translate }}</th>
              <th nzWidth="260px">{{ 'vouchers.budget.cols.note' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let e of entryTable.data; trackBy: trackById">
              <td>{{ e.created_at | date: 'dd/MM/yyyy, h:mm a' }}</td>
              <td>
                <span class="status-tag" [ngClass]="entryKindClass(e.kind)">{{ 'vouchers.budget.kind.' + e.kind | translate }}</span>
              </td>
              <td class="num">
                <span [class.amount-in]="e.amount_usd > 0" [class.amount-out]="e.amount_usd < 0">
                  {{ e.amount_usd > 0 ? '+' : '' }}{{ e.amount_usd | number: '1.2-2' }} USD
                </span>
                <small class="sub" *ngIf="!budgetIsUsd">&asymp; {{ e.amount_local | number: '1.2-2' }} {{ budgetCurrency }}</small>
                <small class="sub" *ngIf="e.batch_currency && e.batch_currency !== 'USD' && e.batch_currency !== budgetCurrency && e.batch_local_amount !== null">
                  {{ e.batch_local_amount | number: '1.2-2' }} {{ e.batch_currency }}
                </small>
              </td>
              <td class="num">
                {{ e.balance_after_usd | number: '1.2-2' }} USD
                <small class="sub" *ngIf="!budgetIsUsd">&asymp; {{ e.balance_after_local | number: '1.2-2' }} {{ budgetCurrency }}</small>
              </td>
              <td class="wrap">{{ e.batch?.name || '-' }}</td>
              <td class="wrap">{{ e.note || '-' }}</td>
            </tr>
          </tbody>
        </nz-table>

        <ng-template #entryEmpty>
          <div class="state-block" *ngIf="budgetState.error as msg; else entryNone">
            <i class="fa-solid fa-triangle-exclamation error-icon"></i>
            <h4>{{ 'vouchers.state.errorTitle' | translate }}</h4>
            <p>{{ msg }}</p>
            <button type="button" class="btn btn-dark" (click)="loadBudget(1)">{{ 'vouchers.state.retry' | translate }}</button>
          </div>
          <ng-template #entryNone>
            <div class="state-block" *ngIf="!budgetState.loading">
              <i class="fa-solid fa-wallet"></i>
              <h4>{{ 'vouchers.budget.ledgerEmptyTitle' | translate }}</h4>
              <p>{{ 'vouchers.budget.ledgerEmptyText' | translate }}</p>
              <button type="button" class="btn btn-primary" *ngIf="canManage && !budget?.pending_request" (click)="openRequest()">
                {{ 'vouchers.budget.request.button' | translate }}
              </button>
            </div>
          </ng-template>
        </ng-template>
      </div>

      <div class="luqta-card" *ngIf="budgetRequests.length">
        <div class="card-heading">
          <h3>{{ 'vouchers.budget.requestsTitle' | translate }}</h3>
        </div>
        <nz-table #requestTable [nzData]="budgetRequests" [nzBordered]="true" [nzScroll]="{ x: '1000px' }"
          [nzFrontPagination]="false" [nzShowPagination]="false">
          <thead>
            <tr>
              <th nzWidth="160px">{{ 'vouchers.budget.cols.sent' | translate }}</th>
              <th nzWidth="130px">{{ 'vouchers.cols.status' | translate }}</th>
              <th nzWidth="170px">{{ 'vouchers.budget.cols.asked' | translate }}</th>
              <th nzWidth="170px">{{ 'vouchers.budget.cols.approved' | translate }}</th>
              <th nzWidth="220px">{{ 'vouchers.budget.cols.yourNote' | translate }}</th>
              <th nzWidth="220px">{{ 'vouchers.budget.cols.luqtaNote' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of requestTable.data">
              <td>{{ r.created_at | date: 'dd/MM/yyyy, h:mm a' }}</td>
              <td>
                <span class="status-tag" [ngClass]="requestStatusClass(r.status)">{{ 'vouchers.budget.requestStatus.' + r.status | translate }}</span>
              </td>
              <td class="num">
                {{ r.amount_usd | number: '1.2-2' }} USD
                <small class="sub" *ngIf="!budgetIsUsd">&asymp; {{ r.amount_local | number: '1.2-2' }} {{ budgetCurrency }}</small>
              </td>
              <td class="num">
                <ng-container *ngIf="r.approved_amount_usd !== null; else dash">
                  {{ r.approved_amount_usd | number: '1.2-2' }} USD
                  <small class="sub" *ngIf="!budgetIsUsd">&asymp; {{ r.approved_amount_local | number: '1.2-2' }} {{ budgetCurrency }}</small>
                </ng-container>
              </td>
              <td class="wrap">{{ r.note || '-' }}</td>
              <td class="wrap">{{ r.admin_note || '-' }}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </ng-container>

  </div>
</div>

<ng-template #dash><span class="muted">-</span></ng-template>

<!-- ───────────────────────── Request budget ───────────────────────── -->
<nz-modal nzClassName="luqta-custom-modal" [nzVisible]="requestVisible" [nzClosable]="!requestSending"
  [nzMaskClosable]="!requestSending" [nzTitle]="'vouchers.budget.request.title' | translate"
  [nzFooter]="requestFooter" (nzOnCancel)="closeRequest()" nzWidth="520px" [nzCentered]="true">
  <ng-container *nzModalContent>
    <div class="budget-request">
      <p class="request-intro">{{ 'vouchers.budget.request.intro' | translate }}</p>

      <div class="form-group">
        <label class="form-label" for="budget-amount">{{ 'vouchers.budget.request.amountLabel' | translate }}</label>
        <div class="amount-input">
          <span class="amount-prefix" aria-hidden="true">USD</span>
          <input id="budget-amount" type="number" class="form-control" min="1" max="1000000" step="1"
            inputmode="decimal" [(ngModel)]="requestAmount" (ngModelChange)="requestError = null"
            (keydown.enter)="submitRequest()"
            [attr.aria-invalid]="requestError && !requestAmountValid ? true : null"
            aria-describedby="budget-amount-hint" />
        </div>
        <small class="field-hint" id="budget-amount-hint">
          <ng-container *ngIf="requestAmountValid && !budgetIsUsd; else plainHint">
            {{ 'vouchers.budget.request.localHint' | translate: { amount: (toLocal(requestAmount) | number: '1.2-2'), currency: budgetCurrency } }}
          </ng-container>
          <ng-template #plainHint>{{ 'vouchers.budget.request.amountHint' | translate }}</ng-template>
        </small>
      </div>

      <div class="form-group">
        <label class="form-label" for="budget-note">{{ 'vouchers.budget.request.noteLabel' | translate }}</label>
        <textarea id="budget-note" class="form-control" rows="3" maxlength="500" [(ngModel)]="requestNote"
          (ngModelChange)="requestError = null" [placeholder]="'vouchers.budget.request.notePlaceholder' | translate"></textarea>
        <small class="field-hint">{{ requestNote.length }} / 500</small>
      </div>

      <div class="inline-alert" role="alert" *ngIf="requestError">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ requestError }}</span>
      </div>
    </div>
  </ng-container>
</nz-modal>

<ng-template #requestFooter>
  <div class="drawer-footer">
    <button type="button" class="btn btn-dark" (click)="closeRequest()" [disabled]="requestSending">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="submitRequest()" [disabled]="requestSending">
      {{ (requestSending ? 'vouchers.budget.request.sending' : 'vouchers.budget.request.submit') | translate }}
    </button>
  </div>
</ng-template>

<!-- ───────────────────────── Create drawer ───────────────────────── -->
<nz-drawer [nzVisible]="createVisible" [nzClosable]="!creating" [nzMaskClosable]="!creating" [nzWidth]="620"
  nzPlacement="right" nzClassName="luqta-custom-drawer vouchers-drawer"
  [nzTitle]="(created ? 'vouchers.create.doneTitle' : 'vouchers.create.title') | translate"
  [nzFooter]="drawerFooter" (nzOnClose)="closeCreate()">
  <ng-container *nzDrawerContent>

    <!-- Form -->
    <div class="drawer-body" *ngIf="!created" [formGroup]="createForm">
      <div class="luqta-card drawer-card">

        <div class="form-group">
          <label class="form-label">{{ 'vouchers.create.mode.label' | translate }}</label>
          <div class="select-options" role="radiogroup">
            <a href="javascript:void(0)" class="option" role="radio" [attr.aria-checked]="createMode === 'single'"
              [class.active]="createMode === 'single'" (click)="setCreateMode('single')">
              {{ 'vouchers.create.mode.single' | translate }}
            </a>
            <a href="javascript:void(0)" class="option" role="radio" [attr.aria-checked]="createMode === 'bulk'"
              [class.active]="createMode === 'bulk'" (click)="setCreateMode('bulk')">
              {{ 'vouchers.create.mode.bulk' | translate }}
            </a>
          </div>
          <small class="field-hint">
            {{ (createMode === 'single' ? 'vouchers.create.mode.singleHint' : 'vouchers.create.mode.bulkHint') | translate }}
          </small>
        </div>

        <div class="form-group">
          <label class="form-label" for="voucher-name">{{ 'vouchers.create.name.label' | translate }}</label>
          <div class="counted-input">
            <input id="voucher-name" type="text" class="form-control" formControlName="name" maxlength="120"
              aria-describedby="voucher-name-count" [placeholder]="'vouchers.create.name.placeholder' | translate" />
            <span class="input-counter" id="voucher-name-count">{{ createForm.get('name')?.value?.length || 0 }}/120</span>
          </div>
          <small class="field-hint">{{ 'vouchers.create.name.hint' | translate }}</small>
        </div>

        <app-voucher-fields [form]="createForm" [currencies]="currencies" [showQuantity]="createMode === 'bulk'"
          [showAllErrors]="showCreateErrors"></app-voucher-fields>

        <!-- What this issue takes from the voucher budget; the server charges the same sum. -->
        <div class="budget-cost" *ngIf="budget" [class.over]="createOverBudget" aria-live="polite">
          <div class="budget-cost-row">
            <span>{{ 'vouchers.budget.cost.label' | translate }}</span>
            <strong *ngIf="createCostUsd !== null; else noCost">{{ createCostUsd | number: '1.2-2' }} USD</strong>
            <ng-template #noCost><strong class="muted">-</strong></ng-template>
          </div>
          <div class="budget-cost-row">
            <span>{{ 'vouchers.budget.available' | translate }}</span>
            <span>
              {{ budget.balance.usd | number: '1.2-2' }} USD
              <small *ngIf="!budgetIsUsd">&asymp; {{ budget.balance.local | number: '1.2-2' }} {{ budgetCurrency }}</small>
            </span>
          </div>
          <div class="budget-cost-row is-left" *ngIf="createLeftUsd !== null">
            <span>{{ 'vouchers.budget.cost.left' | translate }}</span>
            <strong>
              {{ createLeftUsd | number: '1.2-2' }} USD
              <small *ngIf="!budgetIsUsd">&asymp; {{ toLocal(createLeftUsd) | number: '1.2-2' }} {{ budgetCurrency }}</small>
            </strong>
          </div>
          <div class="budget-cost-alert" *ngIf="createOverBudget" role="alert">
            <span>{{ 'vouchers.budget.cost.short' | translate: { amount: (createShortfallUsd | number: '1.2-2') } }}</span>
            <button type="button" class="btn btn-link btn-sm" *ngIf="!budget.pending_request" (click)="requestShortfall()">
              {{ 'vouchers.budget.request.button' | translate }}
            </button>
            <span *ngIf="budget.pending_request">{{ 'vouchers.budget.cost.pendingHint' | translate }}</span>
          </div>
        </div>

        <div class="inline-alert" *ngIf="currenciesError && !currencies.length">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span>{{ currenciesError }}</span>
          <button type="button" class="btn btn-link btn-sm" (click)="loadCurrencies()">{{ 'vouchers.state.retry' | translate }}</button>
        </div>
        <div class="inline-alert" role="alert" *ngIf="createError">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span>{{ createError }}</span>
        </div>
      </div>
    </div>

    <!-- Result -->
    <div class="drawer-body" *ngIf="created">
      <div class="luqta-card drawer-card">
        <div class="result-head">
          <i class="fa-solid fa-circle-check"></i>
          <div>
            <h4>{{ (created.codes.length === 1 && !created.truncated ? 'vouchers.create.issuedOne' : 'vouchers.create.issuedMany') | translate: { count: created.batch?.quantity ?? created.codes.length } }}</h4>
            <p *ngIf="created.batch">
              {{ created.batch.name }} &middot; {{ created.batch.face_value | number: '1.0-2' }} {{ created.batch.currency }}
              &middot; {{ 'vouchers.create.expiresOn' | translate: { date: (created.batch.expires_at | date: 'dd/MM/yyyy':'UTC') } }}
            </p>
          </div>
        </div>

        <div class="inline-alert info" *ngIf="created.truncated">
          <i class="fa-solid fa-circle-info"></i>
          <span>{{ 'vouchers.create.truncated' | translate: { shown: created.codes.length, total: created.batch?.quantity } }}</span>
        </div>

        <div class="result-actions">
          <button type="button" class="btn btn-dark" (click)="copyAllCodes()">
            <i class="fa-regular fa-copy me-2"></i>{{ (codesCopied ? 'vouchers.create.copied' : 'vouchers.create.copyAll') | translate }}
          </button>
          <button type="button" class="btn btn-light filter-btn" (click)="downloadCreatedCodes()">
            <i class="fa-solid fa-file-csv"></i><span>{{ 'vouchers.create.downloadCsv' | translate }}</span>
          </button>
        </div>
        <div class="inline-alert" role="alert" *ngIf="createError">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span>{{ createError }}</span>
        </div>

        <ul class="code-list" [attr.aria-label]="'vouchers.create.codesLabel' | translate">
          <li *ngFor="let c of created.codes">
            <code class="code-text">{{ c.code }}</code>
            <button type="button" class="icon-btn" nz-tooltip [nzTooltipTitle]="'vouchers.actions.copy' | translate"
              [attr.aria-label]="'vouchers.actions.copy' | translate" (click)="copyCode(c.code)">
              <i class="fa-regular fa-copy"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>

</nz-drawer>

<ng-template #drawerFooter>
  <div>
    <div class="drawer-footer" *ngIf="!created">
      <button type="button" class="btn btn-dark" (click)="closeCreate()" [disabled]="creating">
        {{ 'common.cancel' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="submitCreate()" [disabled]="creating || createOverBudget">
        {{ (creating ? 'vouchers.create.creating' : (createMode === 'single' ? 'vouchers.create.submitOne' : 'vouchers.create.submitMany')) | translate }}
      </button>
    </div>
    <div class="drawer-footer" *ngIf="created">
      <button type="button" class="btn btn-dark" (click)="createAnother()">
        {{ 'vouchers.create.another' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="closeCreate()">
        {{ 'vouchers.create.done' | translate }}
      </button>
    </div>
  </div>
</ng-template>
